import { gql } from "@apollo/client";
import {
  BOOLEAN_INPUT_PARTS,
  USER_PARTS,
  COMPANY_ADMIN_PARTS,
  LEARNER_ONBOARDING_PARTS,
  LEARNER_BIOMETRICS_PARTS,
  LEARNER_PARTS,
  LEARNER_ARTICLE_PARTS,
  LEARNER_ARTICLE_CARD_PARTS,
  LEARNER_RECORDING_PARTS,
  LEARNER_RECORDING_CARD_PARTS,
  LEARNER_GROUP_SESSIONS_LIST_PARTS,
  LEARNER_SESSION_CARD_PARTS,
  LEARNER_SESSION_CARD_WEB_PARTS,
  LEARNER_SESSION_CARD_BIOMETRICS_PARTS,
  LEARNER_GROUP_SESSION_PARTS,
  LEARNER_PRACTITIONER_PARTS,
  LEARNER_PRACTITIONER_CARD_PARTS,
  LEARNER_CONTENT_LIST_PARTS,
  LEARNER_PROFILE_SETTINGS_PARTS,
  LEARNER_INDEX_SCREEN_V1_PARTS,
  LEARNER_INDEX_SCREEN_V2_PARTS,
  LEARNER_INDEX_BREAK_DOWN_PILLAR_DETAIL_PARTS_V2,
  LEARNER_INDEX_SCORE_CHANGE_PARTS,
  LEARNER_RECORDINGS_LIST_PARTS,
  LEARNER_MIXED_CONTENT_LIST_PARTS,
  LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS,
  LEARNER_INDEX_BREAK_DOWN_PILLAR_V2_PARTS,
  LEARNER_INDEX_ASSESSMENT_PARTS,
  LEARNER_INDEX_SCORES_MINIMAL_PARTS,
  LEARNER_INDEX_SCORES_CURRENT_PARTS,
  INDEX_SCORE_SNAPSHOT_PARTS,
  OVERALL_INDEX_SCORE_PARTS,
  CATEGORY_SCORE_PARTS,
  DOMAIN_SCORE_PARTS,
  THEME_SCORE_PARTS,
  ITEM_SCORE_PARTS,
  INDEX_SCORE_SNAPSHOT_MINIMAL_PARTS,
  ASSESSMENT_SCHEDULE_PARTS,
} from "./fragment";

export const QUERY_USER = gql`
  query User($email: String!) {
    user(email: $email) {
      ...UserParts
    }
  }
  ${USER_PARTS}
`;

// WONE-612: resolver shipped in WONE-610. Returns the set of auth
// methods available for a given email plus a tri-state user signal that
// drives the unified email-first flow's branching.
//
//   userState: EXISTING | NEW | UNKNOWN_COMPANY
//   methods:   [{ id, name }]
//
// Method ids in play: "google-oauth2", "azuread-oauth2", "okta",
// "email_otp", "email-and-pwd", "magic-link". Visual grouping is a
// client concern; the server returns id + name only.
export const LEARNER_AUTH_METHODS = gql`
  query LearnerAuthMethods($appInfo: AppInfo!, $email: String!) {
    learnerAuthMethods(appInfo: $appInfo, email: $email) {
      userState
      methods {
        id
        name
      }
    }
  }
`;

//QUERY_LEARNER
//DELETE BIOMETRICS USER
export const VITAL_DELETE_USER = gql`
  mutation VitalDeleteUser {
    vitalDeleteUser {
      ok
      user {
        ...UserParts
      }
    }
  }
  ${USER_PARTS}
`;

//CREATE BIOMETRICS USER
export const VITAL_CREATE_USER = gql`
  mutation VitalCreateUser {
    vitalCreateUser {
      ok
      user {
        id
        email
        ...UserParts
      }
    }
  }
  ${USER_PARTS}
`;

//JOIN_OUR_COMMUNITY
export const UPCOMING_GROUP_SESSION_LIST = gql`
  query UpcomingGroupSessionList {
    upcomingGroupSessionList {
      upcomingGroupSessions {
        id
        isLeadingTheSession
        instanceDisplayEndDateTime
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            id
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classType {
            name
          }
          classObj {
            description
          }
          preparationMaterial
          corporateCompany {
            name
          }
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
//JOIN_OUR_COMMUNITY
export const JOIN_OUR_COMMUNITY = gql`
  query JoinOurCommunity($roleName: String!) {
    joinOurCommunity(roleName: $roleName) {
      companySessionToday {
        id
        instanceDisplayEndDateTime
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classType {
            name
          }
          classObj {
            description
          }
          preparationMaterial
          corporateCompany {
            name
          }
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
      companySessionThisWeek {
        id
        instanceDisplayEndDateTime
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classType {
            name
          }
          classObj {
            description
          }
          preparationMaterial
          corporateCompany {
            name
          }
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
      communitySessionToday {
        id
        instanceDisplayEndDateTime
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classObj {
            description
          }
          corporateCompany {
            id
          }
          classType {
            name
          }
          preparationMaterial
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
      communitySessionThisWeek {
        id
        instanceDisplayEndDateTime
        joiningLink
        instanceStartDateTime
        instanceEndDateTime
        sessionEndDateTime
        groupsessionpeoplejoiningSet {
          user {
            userdetail {
              photo
            }
            id
            firstName
            lastName
          }
        }
        groupSession {
          id
          photo
          description
          groupSessionFor
          name
          day
          classObj {
            description
          }
          corporateCompany {
            id
          }
          classType {
            name
          }
          preparationMaterial
        }
        teacher {
          id
          landscapePhoto
          userdetailObj {
            userObj {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
//RECORDINGS
export const RECORDINGS = gql`
  query RecordingsAndArticles {
    recordingsAndArticles {
      recordings {
        id
        recordingUrl
        recordingUrlThumbnail
        recordingDurationText
        teacher {
          id
          userdetailObj {
            userObj {
              firstName
              lastName
            }
          }
        }
        groupSession {
          name
          description
          preparationMaterial
        }
      }
    }
  }
`;
//ARTICLES
export const ARTICLES = gql`
  query RecordingsAndArticles {
    recordingsAndArticles {
      articles {
        id
        photo
        title
        author
      }
    }
  }
`;

//RECORDINGS DETAILS
export const RECORDINGS_DETAILS = gql`
  query GroupSessionInstance($id: ID!) {
    groupSessionInstance(id: $id) {
      id
      recordingUrl
      recordingUrlThumbnail
      recordingDurationText
      teacher {
        userdetailObj {
          userObj {
            firstName
            lastName
          }
        }
      }
      groupSession {
        id
        name
        description
        preparationMaterial
        groupSessionFor
      }
    }
  }
`;
//ARTICLE DETAILS
export const ARTICLE_DETAILS = gql`
  query Article($id: ID!) {
    article(id: $id) {
      id
      title
      author
      photo
      content
    }
  }
`;

//USER FAVORITES ARTICLE
export const USER_FAVORITES_ARTICLE = gql`
  query UserFavorites {
    userFavourites {
      id
      totalArticles
      articles {
        id
        photo
        title
        author
      }
    }
  }
`;

//USER FAVORITES ARTICLES
export const USER_FAVORITES_ARTICLES = gql`
  query UserFavorites {
    userFavourites {
      id
      totalArticles
      articles {
        id
        photo
        title
        author
      }
    }
  }
`;

// USER FAVORITES RECORDINGS

export const USER_FAVORITES_RECORDINGS = gql`
  query UserFavorites {
    userFavourites {
      id
      totalRecordings
      recordings {
        id
        recordingUrl
        recordingUrlThumbnail
        recordingDurationText
        teacher {
          id
          userdetailObj {
            userObj {
              firstName
              lastName
            }
          }
        }
        groupSession {
          name
          description
          preparationMaterial
        }
      }
    }
  }
`;
// STUDENT PROFILE PAGE

export const PILLAR_LIST = gql`
  query PillarList {
    pillarList {
      ordering
      name
      description
    }
  }
`;

export const LEARNER_SCREEN_RECORDINGS = gql`
  query LearnerScreenRecordings(
    $appInfo: AppInfo!
    $searchQuery: String
    $filters: LearnerContentListFilters
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        recordings {
          title
          filteredContentList(
            filters: $filters
            first: $first
            offset: $offset
          ) {
            __typename
            ... on LearnerRecordingsList {
              id
              filters {
                id
                label
                options {
                  id
                  label
                  value
                }
              }
              items(searchQuery: $searchQuery) {
                ...LearnerRecordingCardParts
                __typename
              }
              __typename
            }
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${LEARNER_RECORDING_CARD_PARTS}
`;
export const LEARNER_SCREEN_ARTICLES = gql`
  query LearnerScreenArticles(
    $appInfo: AppInfo!
    $searchQuery: String
    $filters: LearnerContentListFilters
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        articles {
          title
          filteredContentList(filters: $filters) {
            __typename
            ... on LearnerArticlesList {
              id
              items(searchQuery: $searchQuery) {
                ...LearnerArticleCardParts
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_ARTICLE_CARD_PARTS}
`;

export const LEARNER_ARTICLE = gql`
  query LearnerArticle($id: ID!, $appInfo: AppInfo!) {
    learnerArticle(id: $id, appInfo: $appInfo) {
      __typename
      ... on LearnerArticle {
        ...LearnerArticleParts
      }
    }
  }
  ${LEARNER_ARTICLE_PARTS}
`;

export const LEARNER_RECORDING = gql`
  query LearnerRecording($id: ID!, $appInfo: AppInfo!) {
    learnerRecording(id: $id, appInfo: $appInfo) {
      __typename
      ... on LearnerRecording {
        ...LearnerRecordingParts
      }
    }
  }
  ${LEARNER_RECORDING_PARTS}
`;

export const LEARNER_SCREEN_SESSIONS_WEB = gql`
  query LearnerScreenSessionsWeb(
    $appInfo: AppInfo!
    $filters: LearnerContentListFilters!
    $searchQuery: String
  ) {
    learnerScreenSessions(appInfo: $appInfo) {
      __typename
      title
      contentList(filters: $filters) {
        __typename
        ... on LearnerGroupSessionsList {
          id
          filters {
            id
            label
            options {
              id
              label
              value
            }
          }
          items(searchQuery: $searchQuery) {
            ...LearnerSessionCardWebParts
            __typename
          }
          __typename
        }
      }
    }
  }
  ${LEARNER_SESSION_CARD_WEB_PARTS}
`;

export const LEARNER_SCREEN_SCHEDULE = gql`
  query LearnerScreenSchedule($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      screens {
        schedule {
          title
          contentLists {
            __typename
            ... on LearnerSessionsList {
              id
              label
              items {
                ...LearnerSessionCardWebParts
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_SESSION_CARD_WEB_PARTS}
`;

export const LEARNER_SESSION = gql`
  query LearnerSession($id: ID!, $appInfo: AppInfo!) {
    learnerSession(id: $id, appInfo: $appInfo) {
      __typename
      ... on LearnerGroupSession {
        ...LearnerGroupSessionParts
      }
    }
  }
  ${LEARNER_GROUP_SESSION_PARTS}
`;

export const LEARNER_PRACTITIONER = gql`
  query LearnerPractitioner($id: ID!, $appInfo: AppInfo!) {
    learnerPractitioner(id: $id, appInfo: $appInfo) {
      __typename
      ... on LearnerPractitioner {
        ...LearnerPractitionerParts
      }
    }
  }
  ${LEARNER_PRACTITIONER_PARTS}
`;

export const LEARNER_SCREEN_INDEX_V1 = gql`
  query LearnerScreenIndexV1($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          ...LearnerIndexScreenV1Parts
        }
      }
    }
  }
  ${LEARNER_INDEX_SCREEN_V1_PARTS}
`;

export const LEARNER_SCREEN_INDEX_V2 = gql`
  query LearnerScreenIndexV2($appInfo: AppInfo!, $first: Int, $offset: Int) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          ...LearnerIndexScreenV2Parts
        }
      }
    }
  }
  ${LEARNER_INDEX_SCREEN_V2_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_WEEK = gql`
  query LearnerScreenIndexGraphWeek(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          version
          score {
            graph {
              periods {
                week(first: $first, offset: $offset) {
                  ...LearnerIndexScoreDataPeriodParts
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_MONTH = gql`
  query LearnerScreenIndexGraphMonth(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          version
          score {
            graph {
              periods {
                month(first: $first, offset: $offset) {
                  ...LearnerIndexScoreDataPeriodParts
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_YEAR = gql`
  query LearnerScreenIndexGraphYear(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          version
          score {
            graph {
              periods {
                year(first: $first, offset: $offset) {
                  ...LearnerIndexScoreDataPeriodParts
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_WEEK_ENERGY = gql`
  query LearnerScreenIndexGraphWeekEnergy(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            energy {
              score {
                graph {
                  periods {
                    week(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_MONTH_ENERGY = gql`
  query LearnerScreenIndexGraphMonthEnergy(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            energy {
              score {
                graph {
                  periods {
                    month(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_YEAR_ENERGY = gql`
  query LearnerScreenIndexGraphYearEnergy(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            energy {
              score {
                graph {
                  periods {
                    year(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_WEEK_RESILIENCE = gql`
  query LearnerScreenIndexGraphWeekResilience(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            resilience {
              score {
                graph {
                  pillarLabel
                  periods {
                    week(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_MONTH_RESILIENCE = gql`
  query LearnerScreenIndexGraphMonthResilience(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            resilience {
              score {
                graph {
                  pillarLabel
                  periods {
                    month(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_YEAR_RESILIENCE = gql`
  query LearnerScreenIndexGraphYearResilience(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            resilience {
              score {
                graph {
                  pillarLabel
                  periods {
                    year(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_WEEK_ACTIVITY = gql`
  query LearnerScreenIndexGraphWeekActivity(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            activity {
              score {
                graph {
                  pillarLabel
                  periods {
                    week(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_MONTH_ACTIVITY = gql`
  query LearnerScreenIndexGraphMonthActivity(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            activity {
              score {
                graph {
                  pillarLabel
                  periods {
                    month(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_SCREEN_INDEX_GRAPH_YEAR_ACTIVITY = gql`
  query LearnerScreenIndexGraphYearActivity(
    $appInfo: AppInfo!
    $first: Int
    $offset: Int
  ) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          breakdown {
            activity {
              score {
                graph {
                  pillarLabel
                  periods {
                    year(first: $first, offset: $offset) {
                      ...LearnerIndexScoreDataPeriodParts
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_DATA_PERIOD_PARTS}
`;

export const LEARNER_EXERCISE = gql`
  query LearnerScreenExercise($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          exercise {
            title
            subTitle
            videoUrl
            videoThumbnailUrl
            buttonText
          }
        }
      }
    }
  }
`;

export const ENERGY_PILLAR_DETAIL_V2 = gql`
  query energyPillarDetail($appInfo: AppInfo!, $first: Int, $offset: Int) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          showBetaFlag
          breakdown {
            energy {
              ...LearnerIndexBreakdownPillarDetailPartsV2
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_DETAIL_PARTS_V2}
`;

export const RESILIENCE_PILLAR_DETAIL_V2 = gql`
  query resiliencePillarDetail($appInfo: AppInfo!, $first: Int, $offset: Int) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          showBetaFlag
          breakdown {
            resilience {
              ...LearnerIndexBreakdownPillarDetailPartsV2
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_DETAIL_PARTS_V2}
`;

export const ACTIVITY_PILLAR_DETAIL_V2 = gql`
  query activityPillarDetail($appInfo: AppInfo!, $first: Int, $offset: Int) {
    learner(appInfo: $appInfo) {
      id
      screens {
        index {
          showBetaFlag
          breakdown {
            activity {
              ...LearnerIndexBreakdownPillarDetailPartsV2
            }
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_DETAIL_PARTS_V2}
`;

// QUERY_PROFILE
export const LEARNER_SCREEN_PROFILE = gql`
  query LearnerScreenProfile($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      __typename
      id
      fullName
      photoUrl
      biometrics {
        vitalUserId
        providers {
          id
          name
        }
        hasHealthData
        modal {
          title
          contentHtml
          tellMeMoreButtonText
          remindMeLaterButtonText
        }
      }
      screens {
        __typename
        profile {
          __typename
          journey {
            __typename
            title
            memberSince
            discover {
              titleHtml
              subtitleHtml
              buttonText
            }
            timeInvested {
              __typename
              value
              label
              metric
            }
            sessionsAttended {
              __typename
              value
              label
            }
          }

          favourites {
            __typename
            title
            recordings {
              __typename
              count
              label
              contentList {
                __typename
                ... on LearnerRecordingsList {
                  id
                }
              }
            }
            articles {
              __typename
              count
              label
              contentList {
                __typename
                ... on LearnerArticlesList {
                  id
                }
              }
            }
          }
          settings {
            title
            profile {
              ...LearnerProfileSettingsParts
            }
            notifications {
              title
              toggles {
                ...BooleanInputParts
              }
            }
            calendar {
              title
              toggles {
                ...BooleanInputParts
              }
            }
            ourMission {
              title
              heading
              imageUrl
              contentHtml
            }
            membership {
              title
              type
              advantages {
                heading
                items {
                  name
                  description
                }
              }
            }
            biometrics {
              providers {
                title
                providers {
                  id
                  name
                }
              }
              howItWorks {
                title
                headingTitle
                headingContentHtml
                callToAction {
                  title
                  buttonText
                }
                sections {
                  title
                  items {
                    title
                    contentHtml
                  }
                }
              }
            }
          }
          contentLists {
            __typename
            ... on LearnerGroupSessionsList {
              id
              label
              items {
                __typename
                ...LearnerSessionCardParts
              }
            }
          }
        }
      }
    }
  }

  ${BOOLEAN_INPUT_PARTS}
  ${LEARNER_SESSION_CARD_PARTS}
  ${LEARNER_PROFILE_SETTINGS_PARTS}
`;

export const LEARNER_CONTENT_LIST = gql`
  query LearnerContentList(
    $id: ID!
    $searchQuery: String!
    $filters: LearnerContentListFilters!
    $appInfo: AppInfo!
  ) {
    learnerContentList(
      id: $id
      searchQuery: $searchQuery
      filters: $filters
      appInfo: $appInfo
    ) {
      __typename
      ...LearnerContentListParts
      ... on LearnerSessionsList {
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerSessionInterface {
            ...LearnerSessionCardBiometricsParts
          }
        }
      }
      ... on LearnerGroupSessionsList {
        label
        id
        filters {
          id
          label
          options {
            value
            label
            imageUrl
            selected
          }
        }
        items(searchQuery: $searchQuery) {
          __typename
          ...LearnerSessionCardBiometricsParts
        }
      }
      ... on LearnerFeaturedSessionList {
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerSessionInterface {
            ...LearnerSessionCardBiometricsParts
          }
        }
      }
      ... on LearnerRecordingsList {
        label
        id
        filters {
          id
          label
          options {
            value
            label
            imageUrl
            selected
          }
        }
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerRecording {
            ...LearnerRecordingCardParts
          }
        }
      }
      ... on LearnerFeaturedRecordingList {
        label
        id
        filters {
          id
          label
          options {
            value
            label
            imageUrl
            selected
          }
        }
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerRecording {
            ...LearnerRecordingCardParts
          }
        }
      }
      ... on LearnerArticlesList {
        label
        id
        filters {
          id
          label
          options {
            value
            label
            imageUrl
            selected
          }
        }
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerArticle {
            ...LearnerArticleCardParts
          }
        }
      }
      ... on LearnerFeaturedArticleList {
        label
        id
        filters {
          id
          label
          options {
            value
            label
            imageUrl
            selected
          }
        }
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerArticle {
            ...LearnerArticleCardParts
          }
        }
      }
      ... on LearnerPractitionersList {
        items(searchQuery: $searchQuery) {
          __typename
          ... on LearnerPractitioner {
            ...LearnerPractitionerCardParts
          }
        }
      }
    }
  }
  ${LEARNER_CONTENT_LIST_PARTS}
  ${LEARNER_SESSION_CARD_BIOMETRICS_PARTS}
  ${LEARNER_RECORDING_CARD_PARTS}
  ${LEARNER_ARTICLE_CARD_PARTS}
  ${LEARNER_PRACTITIONER_CARD_PARTS}
`;

export const VERIFY_COMPANY_TOKEN = gql`
  query VerifyCompanyToken($appInfo: AppInfo!, $companyToken: String!) {
    verifyCompanyToken(appInfo: $appInfo, companyToken: $companyToken) {
      success
      pageState
      title
      subTitle
      companyLogo
    }
  }
`;

export const LEARNER_AFTER_GROUP_SESSION_FEEDBACK_FORM = gql`
  query LearnerAfterGroupSessionFeedbackForm(
    $groupSessionId: ID!
    $appInfo: AppInfo!
  ) {
    learnerAfterGroupSessionFeedbackForm(
      groupSessionId: $groupSessionId
      appInfo: $appInfo
    ) {
      biometricsBubble {
        title
        contentHtml
      }

      messages {
        title
        senderAvatarUrl
        senderName
        textHtml
        input {
          __typename
          ... on RangeInput {
            id
            label
            required
            min
            minLabel
            max
            maxLabel
            step
            mid
          }
          ... on TextInput {
            id
            label
            required
            minLength
            maxLength
            placeholder
          }
          ... on SelectInput {
            id
            label
            required
            options {
              label
              value
            }
          }
        }
        buttonText
        skipButtonText
      }
      sessionsAttendedThisMonth {
        value
        label
        __typename
      }
    }
  }
`;
export const LEARNER_BEFORE_GROUP_SESSION_FEEDBACK_FORM = gql`
  query LearnerBeforeGroupSessionFeedbackForm(
    $groupSessionId: ID!
    $appInfo: AppInfo!
  ) {
    learnerBeforeGroupSessionFeedbackForm(
      groupSessionId: $groupSessionId
      appInfo: $appInfo
    ) {
      biometricsBubble {
        title
        contentHtml
      }
      messages {
        title
        senderAvatarUrl
        senderName
        textHtml
        input {
          __typename
          ... on RangeInput {
            id
            label
            required
            min
            minLabel
            max
            maxLabel
            step
            mid
          }
          ... on TextInput {
            id
            label
            required
            minLength
            maxLength
            placeholder
          }
          ... on SelectInput {
            id
            label
            required
            options {
              label
              value
            }
          }
        }
        buttonText
        skipButtonText
      }
    }
  }
`;

export const QUERY_COMPANY_ADMIN = gql`
  query companyAdmin($appInfo: AppInfo!) {
    companyAdmin(appInfo: $appInfo) {
      id
      firstName
      lastName
      fullName
      companyName
      photoUrl
      companyType
    }
  }
`;

export const QUERY_USER_PROFILES = gql`
  query UserProfiles($appInfo: AppInfo!, $email: String!) {
    user(email: $email) {
      ...UserParts
    }
    userProfiles(appInfo: $appInfo) {
      learner {
        ...LearnerParts
        onboarding {
          ...LearnerOnboardingParts
        }
        biometrics {
          ...LearnerBiometricsParts
        }
        screens {
          index {
            version
          }
        }
      }
      companyAdmin {
        ...CompanyAdminParts
      }
    }
  }
  ${USER_PARTS}
  ${LEARNER_PARTS}
  ${LEARNER_ONBOARDING_PARTS}
  ${LEARNER_BIOMETRICS_PARTS}
  ${COMPANY_ADMIN_PARTS}
`;

export const QUERY_HOME_SCREEN = gql`
  query LearnerHomeScreen($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      indexScores(excludeBiometrics: true) {
        ...LearnerIndexScoresCurrentParts
      }
      assessmentSchedule {
        ...AssessmentScheduleParts
      }
      screens {
        index {
          score {
            value
            valueFloat
            labelHtml
            change {
              ...LearnerIndexScoreChangeParts
            }
          }
          breakdown {
            energy {
              ...LearnerIndexBreakdownPillarV2Parts
            }
            resilience {
              ...LearnerIndexBreakdownPillarV2Parts
            }
            activity {
              ...LearnerIndexBreakdownPillarV2Parts
            }
            nutrition {
              ...LearnerIndexBreakdownPillarV2Parts
            }
          }
          coach {
            messageTextHtml
            assessmentButton {
              text
              url
            }
            avatarUrl
          }
          assessment {
            ...LearnerIndexAssessmentParts
          }
        }
        home {
          titleHtml
          article {
            ...LearnerArticleParts
          }
          recommendedForYou {
            ...LearnerRecordingsListParts
          }
          trendingNow {
            ...LearnerMixedContentListParts
          }
          upcomingLiveSessions {
            ...LearnerGroupSessionsListParts
          }
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORE_CHANGE_PARTS}
  ${LEARNER_GROUP_SESSIONS_LIST_PARTS}
  ${LEARNER_RECORDINGS_LIST_PARTS}
  ${LEARNER_MIXED_CONTENT_LIST_PARTS}
  ${LEARNER_INDEX_BREAK_DOWN_PILLAR_V2_PARTS}
  ${LEARNER_INDEX_ASSESSMENT_PARTS}
  ${LEARNER_ARTICLE_PARTS}
  ${LEARNER_INDEX_SCORES_CURRENT_PARTS}
  ${ASSESSMENT_SCHEDULE_PARTS}
`;

export const QUERY_RECENT_CONTENT = gql`
  query RecentContent($appInfo: AppInfo!) {
    recentContent(appInfo: $appInfo) {
      ...LearnerRecordingCardParts
    }
  }
  ${LEARNER_RECORDING_CARD_PARTS}
`;

export const QUERY_HIGHLIGHTED_RECORDINGS = gql`
  query LearnerRecordingsHighlighted($appInfo: AppInfo!) {
    learnerContentList(
      id: "LearnerRecordingsHighlighted"
      filters: {}
      searchQuery: ""
      appInfo: $appInfo
      first: 10
    ) {
      __typename
      ... on LearnerRecordingsList {
        items {
          __typename
          ... on LearnerRecording {
            ...LearnerRecordingCardParts
          }
        }
      }
    }
  }
  ${LEARNER_RECORDING_CARD_PARTS}
`;

// # 1: Get latest index scores (minimal)
// # Use case: Quick health check, minimal data transfer
export const LEARNER_INDEX_SCORES_LATEST = gql`
  query LearnerIndexScoresLatest($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        ...LearnerIndexScoresMinimalParts
      }
    }
  }

  ${LEARNER_INDEX_SCORES_MINIMAL_PARTS}
`;

// # 2: Get current index scores with full breakdown
// # Use case: Dashboard/overview screen showing all current scores
export const LEARNER_INDEX_SCORES_CURRENT = gql`
  query LearnerIndexScoresCurrent($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      indexScores(excludeBiometrics: true) {
        ...LearnerIndexScoresCurrentParts
      }
    }
  }

  ${LEARNER_INDEX_SCORES_CURRENT_PARTS}
`;

// # 3: Get index scores with history (default limit: 10)
// # Use case: Showing current scores plus recent historical trend
export const LEARNER_INDEX_SCORES_HISTORY = gql`
  query LearnerIndexScoresHistory($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        ...LearnerIndexScoresCurrentParts
        history {
          ...IndexScoreSnapshotParts
        }
      }
    }

  ${LEARNER_INDEX_SCORES_CURRENT_PARTS}
  ${INDEX_SCORE_SNAPSHOT_PARTS}
  }
`;

// # 4: Get index scores with filtered history
// # Use case: Advanced filtering for specific date ranges, score types, or limits
export const LEARNER_INDEX_SCORES_HISTORY_FILTERED = gql`
  query LearnerIndexScoresHistoryFiltered(
    $appInfo: AppInfo!
    $limit: Int
    $startDate: DateTime
    $endDate: DateTime
    $scoreTypes: [ScoreType]
  ) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        ...LearnerIndexScoresCurrentParts
        history(
          limit: $limit
          startDate: $startDate
          endDate: $endDate
          scoreTypes: $scoreTypes
        ) {
          ...IndexScoreSnapshotParts
        }
      }
    }
  }
  ${LEARNER_INDEX_SCORES_CURRENT_PARTS}
  ${INDEX_SCORE_SNAPSHOT_PARTS}
`;

// # 5: Get only category scores
// # Use case: Category-focused view without unnecessary domain/theme data
export const LEARNER_INDEX_SCORES_CATEGORIES = gql`
  query LearnerIndexScoresCategories($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        overallIndex {
          ...OverallIndexScoreParts
        }
        takenAt
        responseId
        summary
        categories {
          ...CategoryScoreParts
        }
      }
    }
  }

  ${OVERALL_INDEX_SCORE_PARTS}
  ${CATEGORY_SCORE_PARTS}
`;

// # 6: Get only domain scores
// # Use case: Domain-focused view with category relationships
export const LEARNER_INDEX_SCORES_DOMAINS = gql`
  query LearnerIndexScoresDomains($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        overallIndex {
          ...OverallIndexScoreParts
        }
        takenAt
        responseId
        domains {
          ...DomainScoreParts
        }
      }
    }
  }

  ${OVERALL_INDEX_SCORE_PARTS}
  ${DOMAIN_SCORE_PARTS}
`;

// # 7: Get only theme scores
// # Use case: Theme-focused view with domain relationships
export const LEARNER_INDEX_SCORES_THEMES = gql`
  query LearnerIndexScoresThemes($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        overallIndex {
          ...OverallIndexScoreParts
        }
        takenAt
        responseId
        themes {
          ...ThemeScoreParts
        }
      }
    }
  }

  ${OVERALL_INDEX_SCORE_PARTS}
  ${THEME_SCORE_PARTS}
`;

// # 8: Get only item scores
// # Use case: Item-focused view with theme relationships
export const LEARNER_INDEX_SCORES_ITEMS = gql`
  query LearnerIndexScoresItems($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        overallIndex {
          ...OverallIndexScoreParts
        }
        takenAt
        responseId
        items {
          ...ItemScoreParts
        }
      }
    }
  }

  ${OVERALL_INDEX_SCORE_PARTS}
  ${ITEM_SCORE_PARTS}
`;

// # 9: Get historical snapshots only (for trend analysis)
// # Use case: Chart/graph showing trend over time without current breakdown
export const LEARNER_INDEX_SCORES_SNAPSHOTS_ONLY = gql`
  query LearnerIndexScoresSnapshotsOnly(
    $appInfo: AppInfo!
    $limit: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    learner(appInfo: $appInfo) {
      indexScores(excludeBiometrics: true) {
        history(limit: $limit, startDate: $startDate, endDate: $endDate) {
          ...IndexScoreSnapshotMinimalParts
        }
      }
    }
  }

  ${INDEX_SCORE_SNAPSHOT_MINIMAL_PARTS}
`;

const LEARNER_INDEX_SCORES_COMPLETE_PARTS = gql`
  fragment LearnerIndexScoresCompleteParts on Learner {
    id
    assessmentSchedule {
      ...AssessmentScheduleParts
    }
    indexScores(excludeBiometrics: true) {
      overallIndex {
        ...OverallIndexScoreParts
      }
      # The report's written copy, generated in the background once the
      # assessment is submitted. Null where nothing was written, and PENDING
      # while it is still being written, so the screen can say something
      # either way rather than waiting on it.
      report {
        status
        # True while the status is still PENDING but the summary is written:
        # the three summary fields below already carry the learner's copy.
        partialAvailable
        reportHeadline
        modernMeasurement
        ancientWisdom
        strengthsFocus
        areasForGrowth
        # Which domains the copy is about, so the screen can show the same
        # ones it speaks of. Neither is derivable from the scores: the
        # anchor is not always the highest domain, and the lead growth
        # domain is not always the lowest.
        anchorDomain
        leadGrowthDomain
      }
      # Where this learner sits against everyone else. Null until a
      # benchmark has been built, which is the report's unbuilt state
      # rather than an error.
      populationBenchmark {
        percentile
        averageValue
        sampleSize
        windowStart
        windowEnd
        distribution {
          score
          density
        }
      }
      takenAt
      responseId
      summary
      domains {
        ...DomainScoreParts
      }
      themes {
        ...ThemeScoreParts
      }
      items {
        ...ItemScoreParts
      }
      history(limit: $historyLimit) {
        ...IndexScoreSnapshotParts
      }
    }
  }

  ${OVERALL_INDEX_SCORE_PARTS}
  ${DOMAIN_SCORE_PARTS}
  ${THEME_SCORE_PARTS}
  ${ITEM_SCORE_PARTS}
  ${INDEX_SCORE_SNAPSHOT_PARTS}
  ${ASSESSMENT_SCHEDULE_PARTS}
`;

// # 10: Complete data (all current and all historical with full breakdown)
// # Use case: Data export, comprehensive reporting, offline sync
export const LEARNER_INDEX_SCORES_COMPLETE = gql`
  query LearnerIndexScoresComplete($appInfo: AppInfo!, $historyLimit: Int) {
    # Global configuration rather than learner data, so it sits beside the
    # learner rather than inside it, and rides along on the request the
    # scores already make instead of costing a second one.
    scoreScale {
      minValue
      maxValue
      bands {
        key
        name
        minValue
        maxValue
      }
    }
    learner(appInfo: $appInfo) {
      ...LearnerIndexScoresCompleteParts
    }
  }

  ${LEARNER_INDEX_SCORES_COMPLETE_PARTS}
`;

// The report's own query over the same fragment, so only the report selects
// the booked check-in and the Index tab's query is unchanged.
export const LEARNER_ASSESSMENT_REPORT_SCORES = gql`
  query LearnerAssessmentReportScores($appInfo: AppInfo!, $historyLimit: Int) {
    # Global configuration rather than learner data, so it sits beside the
    # learner rather than inside it, and rides along on the request the
    # scores already make instead of costing a second one.
    scoreScale {
      minValue
      maxValue
      bands {
        key
        name
        minValue
        maxValue
      }
    }
    learner(appInfo: $appInfo) {
      ...LearnerIndexScoresCompleteParts
      assessmentSchedule {
        nextCheckInBookedAt
      }
    }
  }

  ${LEARNER_INDEX_SCORES_COMPLETE_PARTS}
`;

export const LEARNER_FEATURE_FLAGS = gql`
  query LearnerFeatureFlags($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      id
      featureFlags {
        name
        enabled
      }
    }
  }
`;

export const TOGGLEABLE_FEATURE_FLAGS = gql`
  query ToggleableFeatureFlags {
    toggleableFeatureFlags {
      name
      enabled
    }
  }
`;

export const LEARNER_ASSESSMENT_SCHEDULE = gql`
  query LearnerAssessmentSchedule($appInfo: AppInfo!) {
    learner(appInfo: $appInfo) {
      __typename
      id
      assessmentSchedule {
        ...AssessmentScheduleParts
      }
    }
  }
  ${ASSESSMENT_SCHEDULE_PARTS}
`;

export const ADVENT_CAMPAIGN = gql`
  query AdventCampaign {
    adventCampaign {
      id
      name
      slug
      startDate
      endDate
      introTitle
      introBody
      totalDoors
      openedCount
      doors {
        id
        dayNumber
        date
        category
        doorType
        title
        subtitle
        whyThisHelps
        contentId
        contentAvailable
        oriCtaLabel
        oriPrompt
        closingCopy
        mechanic
        mechanicConfig
        isOpened
        openedAt
        isCompleted
        completedAt
        response
        invite {
          localTime
          timeZone
          durationMinutes
          sentAt
          startsAt
          delivery
        }
      }
    }
  }
`;
